import Head from 'next/head'
import { useRouter } from 'next/router'
import React from 'react'

import { historyUtils } from '@wartek-id/toolbox-helper'
import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'

import ArrowLeftIcon from 'assets/icons/arrow-left.svg'

export const Header = () => {
  const title = 'Pengajuan Hapus Akun'
  const router = useRouter()

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <HeaderBar fixed>
        <HeaderBarLeftAction
          onClick={() =>
            historyUtils.backToApp(() => {
              if (window.history.state.idx <= 1) router.push('/home')
              else router.back()
            })
          }
        >
          <ArrowLeftIcon
            width={24}
            height={24}
            className="fill-current text-icon-default"
          />
        </HeaderBarLeftAction>
        <HeaderBarTitle>{title}</HeaderBarTitle>
      </HeaderBar>
    </>
  )
}
